module.exports = __webpack_public_path__ + "media/images/prediction/special/condor/img_thumb-e149d003c22fe70ce6ee85e1cc3b6f23.jpg";